/**
 * created by tian ruo jun
 * 其他设置（站群字段）
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon, Switch} from "antd";

export default class OtherSetting extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        // wbiscomment; //是否禁止评论
        // wbcopyenable; //是否禁止拷贝
        // wbsecurity; //是否加密
        // 是：1 否：0
        this.state = {
            properties: true,
            formData: {
                wbiscomment: 0,
                wbcopyenable: 0,
                wbsecurity: 0,
            },
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getData = () => {
        return this.state.formData
    };

    setData = (data) => {
        this.state.formData = {
            ...this.state.formData,
            wbiscomment: data.wbiscomment?1:0,
            wbcopyenable: data.wbcopyenable?1:0,
            wbsecurity: data.wbsecurity?1:0,
        };
        this.setState({});
    };

    render() {
        const {properties} = this.state;
        return (
            <>
                <div className="otherAttributes">
                    <div className="overstriking">其他设置</div>
                    <div><Icon className="lineIcon" type={properties ? "down" : "up"}
                               onClick={this.propertiesInfor}/>
                    </div>
                </div>
                {this.renderSetting()}
            </>
        )
    }

    renderSetting = () => {
        const {properties} = this.state;
        let config = [
            {
                label: "禁止评论",
                content: "是否关闭评论功能",
                value: "this.state.formData.wbiscomment",
            },
            {
                label: "禁止拷贝",
                content: "是否禁止拷贝内容",
                value: "this.state.formData.wbcopyenable",
            },
            {
                label: "是否加密",
                content: "是否加密存储内容",
                value: "this.state.formData.wbsecurity",
            },
        ];
        // console.log(eval("this.state.formData.encryption"))
        return (
            properties ?
                <div style={{padding: "9px 0px"}}>
                    {
                        config.map(item => {
                            // console.log(eval("this.state.formData.encryption"))
                            return this.renderSettingItem(item)
                        })
                    }
                </div>
                : ''
        )
    };

    renderSettingItem = (item) => {
        return (
            <div
                key={item.value}
                style={{
                    padding: "9px 0px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <div>
                    <label style={{marginRight: 8}}>{item.label}</label>
                    <span style={{color: "#F56C6C"}}>{item.content}</span>
                </div>
                <div>
                    <Switch
                        checked={eval(item.value)===1?true:false}
                        onChange={checked => {
                            let val = checked?1:0;
                            this.onChange({code: item.value, val: val, setState: true})
                        }}
                        checkedChildren="开"
                        unCheckedChildren="关"
                        defaultChecked/>
                </div>
            </div>
        )
    };

    propertiesInfor = () => {
        const {properties} = this.state;
        this.setState({
            properties: !properties,
        })
    };

    onChange = ({code, val, setState = false}) => {
        eval(`${code}=val`);
        // 方案一 eval(`obj.${key}=value`);
        // 方案二 new Function('obj','key','value',`obj.${key}=value`)(obj,key,value);
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({});
        }
    };

}